import {match, Pattern} from 'ts-pattern';

import {identity} from 'ramda';
import {isEmptyArray} from 'ramda-adjunct';

import {EMPTY_PLACEHOLDER} from 'shared/web';

export interface VehicleSelectionOutcomeValueFormatters {
  formatNumber?: (value: number) => string;
  formatText?: (value: string) => string;
}

const formatPlainNumber = (value: number) => value.toString();

// `expected` and `actual` of an outcome are untyped JSON: a code or number, a list of them, a
// {from, to} range, a date string or null when the listing has no value. Numbers and texts go
// through the given formatters, inside lists and ranges too, so a price can be shown as an amount
// and an ID or code as its label.
export const formatVehicleSelectionOutcomeValue = (
  value: unknown,
  formatters: VehicleSelectionOutcomeValueFormatters = {}
): string => {
  const formatNumber = formatters.formatNumber ?? formatPlainNumber;
  const formatText = formatters.formatText ?? identity<string>;

  return match(value)
    .with(Pattern.nullish, () => EMPTY_PLACEHOLDER)
    .with(Pattern.when(isEmptyArray), () => EMPTY_PLACEHOLDER)
    .with(Pattern.array(), (items) =>
      items.map((item) => formatVehicleSelectionOutcomeValue(item, formatters)).join(', ')
    )
    .with(
      {from: Pattern._, to: Pattern._},
      (range) =>
        `${formatVehicleSelectionOutcomeValue(range.from, formatters)} – ${formatVehicleSelectionOutcomeValue(range.to, formatters)}`
    )
    .with(Pattern.number, formatNumber)
    .with(Pattern.string, formatText)
    .with(Pattern.boolean, (flag) => flag.toString())
    .otherwise((other) => JSON.stringify(other));
};
